import React, { useEffect, useState, useRef } from "react";
import EmployeeSearch from "./EmployeeSearch";
import { getAdminEmployeeList } from "./apis/EmployeeSearchApi";

const EmployeeSearchAdmin = ({ onSelect, preselectedEmployee = null, useRsEmployeeId = false, initialEmployeeId = null, includeTerminated = false, onTerminatedRequired = null }) => {
    const [empList, setEmpList] = useState([]);
    const [isEmpsLoading, setIsEmpsLoading] = useState(true);
    const [derivedPreselectedEmployee, setDerivedPreselectedEmployee] = useState(preselectedEmployee);
    const hasCheckedForTerminated = useRef(false);

    useEffect(() => {
        async function fetchEmployees() {
            setIsEmpsLoading(true);
            try {
                const employees = await getAdminEmployeeList(includeTerminated);
                setEmpList(employees);
                setIsEmpsLoading(false);
            } catch (error) {
                console.error("Error fetching admin employee list:", error);
                setIsEmpsLoading(false);
            }
        }

        fetchEmployees();
    }, [includeTerminated]);

    // Handle initial employee preselection for display only (don't call onSelect)
    useEffect(() => {
        if (!isEmpsLoading && initialEmployeeId && empList.length > 0) {
            const employee = empList.find(emp => emp.employeeId === initialEmployeeId);
            if (employee) {
                setDerivedPreselectedEmployee(employee);
                // Note: NOT calling onSelect here - this is just for visual display
                // Data loading is handled by the parent using initialEmployeeId directly
            } else if (!includeTerminated && !hasCheckedForTerminated.current && onTerminatedRequired) {
                // Employee not found in active list, request to include terminated employees
                hasCheckedForTerminated.current = true;
                onTerminatedRequired();
            }
        }
    }, [isEmpsLoading, initialEmployeeId, empList, includeTerminated, onTerminatedRequired]);

    return (
        <EmployeeSearch
            employeeList={empList}
            isLoading={isEmpsLoading}
            onSelect={onSelect}
            preselectedEmployee={derivedPreselectedEmployee}
            useRsEmployeeId={useRsEmployeeId}
        />
    );
};

export default EmployeeSearchAdmin;
